import {AfterViewInit, Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ToolsService} from './tools.service';
import {Location} from './tools.models';
import {FormControl} from '@angular/forms';
import * as moment from 'moment';

@Component({
    selector: 'app-tools',
    templateUrl: './tools.component.html',
    styleUrls: ['./tools.component.css']
})
export class ToolsComponent implements AfterViewInit {

    locations: Array<Location>;
    isLoadingResults = true;
    progress = false;
    selectedLocation: Location;
    fromDate = new FormControl();
    toDate = new FormControl();
    synchronizeMappings = false;

    constructor(public route: ActivatedRoute,
                public router: Router,
                public toolsService: ToolsService,
                private _snackBar: MatSnackBar) {
    }

    ngAfterViewInit() {
        this.toolsService.findAllLocations().subscribe(
            locations => {
                this.locations = locations;
                this.isLoadingResults = false;
            },
            error => {
                console.log(error);
                this.isLoadingResults = false;
            });
    }

    reconcileJournals() {
        this.progress = true;
        let request = [];
        let startDate = moment(this.fromDate.value);
        let endDate = moment(this.toDate.value);
        while (startDate <= endDate) {
            request.push({
                locationId: this.selectedLocation.vetSourceId,
                transactionDate: startDate.format('YYYY-MM-DD')
            });
            startDate = startDate.add(1, 'day');
        }
        this.toolsService.reconcileJournals(request, this.synchronizeMappings).subscribe(
            locations => {
                this.progress = false;
                this._snackBar.open('The reconciliation task has been accepted. It will run in background.', 'Close', {
                    duration: 5000,
                });
            },
            error => {
                console.log(error);
                this.progress = false;
            });
    }
}
